import { AxiosResponse } from 'axios'
import { http } from '@/core/realisations/Http.realisation'

import { BlogGetArticleResponse, BlogGetArticlesParams, BlogGetArticlesResponse } from '../types/blog.types'

export class BlogRepository {
    getArticles(params: BlogGetArticlesParams): Promise<AxiosResponse<BlogGetArticlesResponse>> {
        return http.get('/vacancy/api/blogs', { params })
    }

    getArticle(article_id: number): Promise<AxiosResponse<BlogGetArticleResponse>> {
        return http.get(`/vacancy/api/blogs/${article_id}`)
    }

    createArticle(payload: FormData): Promise<AxiosResponse<void>> {
        return http.postFormData('/vacancy/api/blogs', payload)
    }

    updateArticle(article_id: number, payload: FormData): Promise<AxiosResponse<void>> {
        return http.postFormData(`/vacancy/api/blogs/${article_id}`, payload)
    }

    deleteArticle(article_id: number): Promise<AxiosResponse<void>> {
        return http.delete(`/vacancy/api/blogs/${article_id}`)
    }
}